

<template>
<div>

  <!-- Navbar -->
 
  <!-- Navbar -->
  <!-- data-ride="carousel" -->
  <!--Carousel Wrapper-->


  <div class="view">

          <!--Video source-->
          <video class="video-intro" autoplay loop muted>
            <source src="https://mdbootstrap.com/img/video/animation-intro.mp4" type="video/mp4" />
          </video>

          <!-- Mask & flexbox options-->
          <div class="mask rgba-black-light d-flex justify-content-center align-items-center">

            <!-- Content -->
            <div class="text-center white-text mx-5 wow fadeIn">
              <h1 class="mb-4">
                <strong>Use your certificates from your mobile device </strong>
              </h1>

              <p>
                <strong>Easily, anywhere, anytime</strong>
              </p>

              <p class="mb-4 d-none d-md-block">
                <strong>Personal Signer makes it easy to sign documents using your certificates in your mobile device</strong>
              </p>

         <!--     <a target="_blank" href="https://mdbootstrap.com/education/bootstrap/" class="btn btn-outline-white btn-lg">Watch Video
                <i class="fas fa-graduation-cap ml-2"></i>
              </a>  -->
            </div>
            <!-- Content -->

          </div>
          <!-- Mask & flexbox options-->

        </div>


    
  <!--Main layout-->
  <main>
    <div class="container">

      <!--Section: Main info-->
      <section class="mt-5 wow fadeIn">

        <!--Grid row-->
        <div class="row">

          <!--Grid column-->
          <div class="col-md-6 mb-4">

            <img src="@/assets/Fondopuntos.png" class="img-fluid z-depth-1-half" alt="">

          </div>
          <!--Grid column-->

          <!--Grid column-->
          <div class="col-md-6 mb-4">

            <!-- Main heading -->
            <h3 class="h3 mb-3">Personal Signer for iOS and Android</h3>
            <p>Personal Signer is the app that  turrns your mobile device into the tool you need for signing using your certificates anywhere you go </p>
            <!-- Main heading -->

            <hr>

            <p>
              <strong>Sign</strong> any PDF document,
              <strong>Advanced signature</strong> using standards,
              <strong>Timestamp</strong> your documents using a Certified Authority, 
              <strong>Share</strong> any signed document
            </p>

            <!-- CTA -->
            <a target="_blank" href="http://itunes.apple.com/app/id1531755326" >
           <img src="@/assets/app-store-badge.png"  alt="">
            </a>


          </div>
          <!--Grid column-->

        </div>
        <!--Grid row-->

      </section>
      <!--Section: Main info-->

      <hr class="my-5">



      
                    <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-4by3">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/7QWmjEG8WGY?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->


                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Sign a document</strong>
                        </h3>
                        <p class="grey-text">An easy and secure way to sign documents from any location </p>
                        <p>
                            <strong>Secure Sign using your face or fingerprint </strong>
                        </p>
 
                    </div>
                    </div>
      <hr class="my-5">

      <!--Section: Not enough-->
      <section>

        <h2 class="my-5 h3 text-center">About Personal Signer</h2>

        <!--First row-->
        <div class="row features-small mb-5 mt-3 wow fadeIn">

          <!--First column-->
          <div class="col-md-4">
            <!--First row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Sign anywhere</h6>
                <p class="grey-text">You can take your certificates with you.
                </p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/First row-->

            <!--Second row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Advanced Signature</h6>
                <p class="grey-text">Using a valid certificate, it complies with  the Advanced Electronic Signature schema.
                </p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Second row-->

            <!--Third row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Use your face or fingerprint</h6>
                <p class="grey-text">You can use the biometric identification in your device to unlock the certificate for signing.</p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Third row-->

            <!--Fourth row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Timestamp functionality</h6>
                <p class="grey-text">In case  you just want to timestamp a document without signing it .</p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Fourth row-->
          </div>
          <!--/First column-->

          <!--Second column-->
          <div class="col-md-4 flex-center">
              
            <img src="@/assets/pssccreen1.png" alt="iPhone" class="z-depth-0 img-fluid" width="200px">
          </div>
          <!--/Second column-->

          <!--Third column-->
          <div class="col-md-4 mt-2">
            <!--First row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Several configuration options</h6>
                <p class="grey-text">You can set the initial position of the visible signature, wether to use biometrics or not and more.
                </p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/First row-->

            <!--Second row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Position it anywhere in yur document</h6>
                <p class="grey-text">The visible stamp can be postioned in any page you want and you can move and resize it within that page</p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Second row-->

            <!--Third row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Several ways to load documents</h6>
                <p class="grey-text">Browse your device, share them from other app or get them from an external URL
                </p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Third row-->

            <!--Fourth row-->
            <div class="row">
              <div class="col-2">
                <i class="fas fa-check-circle fa-2x indigo-text"></i>
              </div>
              <div class="col-10">
                <h6 class="feature-title">Easy to use and customize</h6>
                <p class="grey-text">Using Personal Signer is straightforward and pleasant. Sign any document in seconds.</p>
                <div style="height:15px"></div>
              </div>
            </div>
            <!--/Fourth row-->
          </div>
          <!--/Third column-->

        </div>
        <!--/First row-->

      </section>
      <!--Section: Not enough-->

      <hr class="mb-5">

      <!--Section: More-->
   
      <!--Section: More-->
    <contact-form />
    </div>
  </main>
  <!--Main layout-->

  <!--Footer-->
 
  <!--/.Footer-->

  <!-- SCRIPTS -->
  <!-- JQuery -->
</div>
</template>

<script>
import ContactForm from "./ContactForm";
  import axios from "axios";

export default {
  name: 'HelloWorld',
  data () {
      
    return {
                items: [
          {
            img: true,
            src:
              "https://mdbootstrap.com/img/Photos/Slides/img%20(130).jpg"
          },
          {
            img: true,
            src:
              "https://mdbootstrap.com/img/Photos/Slides/img%20(129).jpg"
          },
          {
            img: true,
            src:
              "https://mdbootstrap.com/img/Photos/Slides/img%20(70).jpg"
          }
        ],
      msg: 'Welcome to zzzzzzxxxxxz MDB Vue.js App'
    };
  },
    components: {
    ContactForm,

  },
 
}





</script>
<style scoped>
    /* Necessary for full page carousel*/
    html,
    body,
    header,
    .view {
      height: 350px;
    }

    /* Carousel*/
    .carousel,
    .carousel-item,
    .carousel-item.active {
      height: 100%;
    }
    .carousel-inner {
      height: 100%;
    }

    @media (min-width: 800px) and (max-width: 850px) {
      .navbar:not(.top-nav-collapse) {
          background: #1C2331!important;
      }
  }

</style>